
export const MUTATIONS_CONFIGURATIONS = {
  UPDATE_CONFIGURATIONS: 'updateConfigurations'
};
export default {
  updateConfigurations(state, configurations) {
    state.configurations = configurations;
  },
};